import CloseIcon from "@mui/icons-material/Close";

export default function SpecsModal({
  open,
  product,
  onClose,
  brandColors,
  selectedBrand,
}) {
  if (!open || !product) return null;

  const isKarstenLayout = selectedBrand === "karsten";

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 60,
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: brandColors.surface,
          borderRadius: "8px",
          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
          padding: "24px",
          maxWidth: "448px",
          width: "100%",
          textAlign: "left",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: "16px",
          }}
        >
          <div>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                fontFamily: "inherit",
              }}
            >
              {product.name}
            </h3>
            <p
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: brandColors.primary,
              }}
            >
              Especificações
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              color: brandColors.textMuted,
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
            onMouseEnter={(e) =>
              (e.target.style.color = brandColors.textBase)
            }
            onMouseLeave={(e) =>
              (e.target.style.color = brandColors.textMuted)
            }
          >
            <CloseIcon style={{ fontSize: "24px" }} />
          </button>
        </div>
        <div
          style={{
            fontSize: "14px",
            color: brandColors.textMuted,
            backgroundColor: isKarstenLayout ? "#f9fafb" : brandColors.bg,
            padding: "16px",
            borderRadius: "8px",
          }}
        >
          {product.specs
            ? product.specs.split(";").map((spec, idx) => (
                <p key={idx} style={{ margin: idx > 0 ? "8px 0 0 0" : 0 }}>
                  {spec.trim()}
                </p>
              ))
            : "Sem especificações disponíveis."}
        </div>
      </div>
    </div>
  );
}

